module.exports = __webpack_public_path__ + "static/media/dev-icon.b51f7e07.svg";